exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".point-tag{background-color:#fdeba1;border-radius:50%;color:#000;font-size:12px;position:relative;width:20px!important;height:20px!important;text-align:center;-ms-flex-line-pack:center;align-content:center}", "", {"version":3,"sources":["/home/ponce-dev-production/report/src/components/Additions/CropMap.vue"],"names":[],"mappings":"AACA,WACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,qBAAuB,AACvB,sBAAwB,AACxB,kBAAmB,AACnB,0BAA2B,AACvB,oBAAsB,CAC3B","file":"CropMap.vue","sourcesContent":["\n.point-tag {\n  background-color: #FDEBA1;\n  border-radius: 50%;\n  color: #000000;\n  font-size: 12px;\n  position: relative;\n  width: 20px !important;\n  height: 20px !important;\n  text-align: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bcf227a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Additions/CropMap.vue
// module id = 1514
// module chunks = 0